module.exports = __webpack_public_path__ + "img/4.d535f2a9.jpg";